// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"102":"b93feeb4a1ded395","869":"926633de9c1d90cf"}[chunkId] + ".js";
};